import Api from '../http.service';

/**
 * update users profile
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.userName
 * @param {String} payload.data.password
 * @param {String} payload.data.firstName
 * @param {String} payload.data.lastName
 * @param {String} payload.data.email
 * @param {Object} payload.data.basicInfo
 * @param {String} payload.data.basicInfo.mobile
 * @param {String} payload.data.basicInfo.mobileWithoutCode
 * @param {String} payload.data.basicInfo.countryAbr
 * @param {String} payload.data.basicInfo.avatar
 */

export const signup = (payload) =>
  Api.POST({ url: 'users/profile', data: { ...payload.data } });

/**
 * login
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.userName
 * @param {String} payload.data.password
 */
export const login = (payload) =>
  Api.POST({ data: payload.data, url: 'users/login' });

/**
 * Refresh Toekn
 * @param {Object} payload
 * @param {Object} payload.data.
 * @param {String} payload.data.token
 */
export const RefreshToken = ({ token }) =>
  Api.POST({ data: { token }, url: 'users/refresh_token' });

/**
 * login
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.contact
 * @param {String} payload.data.send_type
 */
export const otpLogin = (payload) =>
  Api.POST({ data: payload.data, url: 'users/login_otp' });

/**
 * login
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.contact
 * @param {String} payload.data.code
 */
export const otpVerify = (payload) =>
  Api.POST({ data: payload.data, url: 'users/verify_otp' });

/**
 * call reset password api
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.oldPassword
 * @param {String} payload.data.password
 */
export const changePassword = (payload) =>
  Api.PUT({ url: 'users/change_password', data: { ...payload.data } });

/**
 * get employee by username
 * @param {Object} payload
 * @param {String} payload.username
 */
export const getNameByUsername = (payload) =>
  Api.GET({ url: `users/email/${payload.username}` });

/**
 * get employee of businessProfile
 * @param {Object} payload
 * @param {Number} payload.profileId
 * @param {Number} payload.itemPerPage
 * @param {Number} payload.pageNumber
 * @param {Object} payload.data
 * @param {String} payload.data.phrase
 * @param {Number} payload.data.departmentId
 */
export const employeeListByProfileId = (payload) =>
  Api.POST({
    url: `users/employee/${payload.profileId}/${payload.pageNumber - 1}/${
      payload.itemPerPage
    }`,
    data: payload.data,
  });

/**
 * add employee
 * @param {Object} payload
 * @param {Object} payload.data
 */
export const addEmployee = (payload) =>
  Api.POST({
    data: payload.data,
    url: 'users/employee',
  });

/**
 * update employee
 * @param {Object} payload
 * @param {Object} payload.data
 */
export const updateEmployee = (payload) =>
  Api.PUT({
    data: payload.data,
    url: 'users/employee',
  });
/**
 * reset user password
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.guid
 * @param {String} payload.data.hash
 * @param {String} payload.data.newPassword
 */
export const resetPassword = (payload) =>
  Api.POST({ url: 'users/reset_pass', data: payload.data });

/**
 * get employee info
 * @param {Object} payload
 * @param {String} payload.employeeId
 * @param {String} payload.profileId
 */
export const employeeInfo = (payload) =>
  Api.GET({
    url: `users/id_business/${payload.employeeId}/${payload.profileId}`,
  });
/**
 * googleLogin
 * @param {Object} basicInfo
 * @param {String} payload.userName
 * @param {String} payload.firstName
 * @param {String} payload.lastName
 * @param {String} payload.email
 */
export const googleLogin = (payload) =>
  Api.POST({ data: payload, url: 'users/google' });

/**
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.secondPassword
 */
export const setSecondPassword = (payload) =>
  Api.PUT({ data: payload.data, url: 'users/change_second_password' });
